import * as React from 'react';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { StyledButton, StyledCancelButton, Textarea } from '../StyledComponent';
import { weightRegex } from '../../regex/regex';
import { post, patch } from '../../services/api-services';
import { useCommon } from '../../context/CommonContext';
import { getCurrentDateTime } from '../../modules/ConvertDate';
import { useParams } from 'react-router-dom';

export default function AddWeight({
    openAddWeight,
    setOpenAddWeight,
    weight,
    setWeight,
    setWeightData,
    weightData,
    getWeightData,
    getCurrentWeight,
    weightGoalParcent,
    userData,
    fetchUserData,
    source
}) {
    const { id } = useParams();
    const { setSnackbar } = useCommon();


    const handleClose = () => {
        setOpenAddWeight(false);
    };







    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            if ((userData && userData.weight) || source === "casePage") {
                const res = await post("/Measurements", { ...weight, value: Number(weight.value) });
                if (res?.statusCode === 200) {
                    if (source !== "casePage") {
                        await getCurrentWeight()
                    }

                    setSnackbar({
                        openSnackbar: true,
                        message: "Weight added successfully!",
                        severity: "success",
                    });
                } else {
                    throw new Error("Failed to add weight.");
                }
            } else {
                const { targetWeight } = await weightGoalParcent(userData?.height, userData?.gender, userData?.dateOfBirth, userData?.weightGoal, Number(weight?.value), Number(weight?.value));
                const patchWeightResponse = await patch(`/Customers/${id}`, {
                    weight: Number(weight.value),
                    weightGoal: targetWeight,
                });
                if (patchWeightResponse?.statusCode === 200) {
                    const res = await post("/Measurements", { ...weight, value: Number(weight.value) });
                    if (res?.statusCode === 200) {
                        setSnackbar({
                            openSnackbar: true,
                            message: "Weight added successfully!",
                            severity: "success",
                        });
                        await getCurrentWeight();
                        await fetchUserData();
                    } else {
                        throw new Error("Failed to add weight.");
                    }
                } else {
                    throw new Error("Failed to update customer weight.");
                }
            }
        } catch (error) {
            console.error("Error in handleSubmit:", error);
            setSnackbar({
                openSnackbar: true,
                message: error.message || "An error occurred!",
                severity: "error",
            });
        } finally {
            setWeight((prev) => ({
                ...prev,
                value: "",
                userComment: "",
                recordedAt: getCurrentDateTime(),
                customerId: "",
            }));
            handleClose();
        }
    };



    return (
        <React.Fragment>
            <Dialog
                open={openAddWeight}
                onClose={handleClose}
                fullWidth
                PaperProps={{
                    component: 'form',
                    onSubmit: handleSubmit,
                }}
            >
                <DialogTitle>Add Weight</DialogTitle>
                <DialogContent className='flex flex-col gap-5'>
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        id="weight"
                        name="weight"
                        label="Weight (In kgs)"
                        type="text"
                        inputMode="decimal"
                        fullWidth
                        variant="standard"
                        value={weight?.value}
                        onChange={(e) => {
                            const raw = e.target.value;
                            // Allow empty, or valid numeric input (digits with optional single decimal point)
                            if (raw === '' || /^\d*\.?\d*$/.test(raw)) {
                                // Strip leading zeros (but keep "0." for decimals)
                                const cleaned = raw === '' ? '' : raw.replace(/^0+(?=\d)/, '');
                                setWeight((prev) => ({ ...prev, value: cleaned }));
                            }
                        }}
                        inputProps={{ maxLength: 5 }}
                        error={!!(weight?.value && (!weightRegex.test(Number(weight?.value)) || (Number(weight?.value) >= 300 || Number(weight?.value) <= 20)))}
                        helperText={
                            (weight?.value && (Number(weight?.value) >= 300 || Number(weight?.value) <= 20)) ?
                                "Weight should be between 20 to 300 kgs" : ''
                        }
                    />

                    <Textarea
                        rows="4"
                        placeholder='Add a comment... (optional)'
                        style={{ marginTop: '25px' }}
                        value={weight?.userComment}
                        onChange={(e) => setWeight((prev) => ({ ...prev, userComment: e.target.value }))}
                    />
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        id="name"
                        name="email"
                        label="Choose date and time"
                        type="datetime-local"
                        fullWidth
                        variant="standard"
                        value={weight?.recordedAt}
                        onChange={(e) => setWeight((prev) => ({ ...prev, recordedAt: e.target.value }))}
                    />
                </DialogContent>
                <DialogActions>
                    <StyledCancelButton onClick={handleClose}>Cancel</StyledCancelButton>
                    <StyledButton type="submit" disabled={!weight?.value || !weightRegex.test(Number(weight?.value)) || !weight?.recordedAt}>ADD</StyledButton>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
